<div class="graphic-element">
	<span *ngIf="!connectionsList || connectionsList.length === 0">{{
		'connectionsModal.graphicElement.transferOut' | translate
	}} </span>
	<span *ngIf="connectionsList && connectionsList.length === 1">
		{{ 'connectionsModal.graphicElement.connections' | translate }}
		<small>{{ 'connectionsModal.graphicElement.connectionsAlt' | translate }}</small>
	</span>
</div>

<div class="cards-list" *ngIf="connectionsList">
	<app-sliding-card
		*ngFor="let connection of connectionsList"
		[cardText]="connection.serverAlias"
		[isDeleteDisabled]="connectionsList.length === 1"
		(selectedCard)="selectConnection(connection)"
		(editConnection)="editConnection(connection.connectionId)"
		(deleteConnection)="deleteConnection(connection.connectionId)"
	></app-sliding-card>
</div>

<ul class="footer">
	<li (click)="addNewConnection()">
		<ion-icon class="icon-Add"></ion-icon> {{ 'connectionsModal.buttons.newConnection' | translate }}
	</li>
</ul>
